import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Premi 'Esporta' per generare i Word o i PDF della verifica. Premi 'Salva come nuovo' per creare da zero una verifica, la troverai nel tuo archivio se volessi modificarla. Premi 'Aggiorna' per sovrascrivere una verifica già esistente. Premi 'Elimina' per cancellare la verifica dal tuo archivio.",
        name: 'HomeworkPageAnchor',
        tutorialName: 'dettaglio-verifica-docente-salvata_pulsantiera'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
